import { RouteConfig } from 'vue-router';

export const setPasswordRoute: RouteConfig = {
  path: '/set/:token',
  name: 'set',
  component: () => import(/* webpackChunkName: "SetPassword" */ '@/views/startRoute/SetPassword.vue')
};
